module.exports = __webpack_public_path__ + "jamaica.svg?a1da9686077291ab4412e97ac97f5fd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/jamaica.svg
// module id = 199
// module chunks = 10